import { VisitorShortFields } from "../types/interfaces.ts";

export const initShortVisitor: VisitorShortFields = {
    firstName: "",
    lastName: "",
    id: 0,
    dateCreated: "", 
    phone: '', 
    visitorId: -1
  };